import Vue from 'vue';
import vuex from 'vuex';

Vue.use(vuex)

export default  new vuex.Store({
    state: {
        userInfo: {},
        cardId: ''
    },
    mutations: {
        changeInfo(state,data) {
            state.userInfo = data
        },
        changeCard(state,data) {
            state.cardId = data
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js